import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getLastFullContext } from './lastFullContext';
import { pushSituationalAwareness } from './pushSituationalAwareness';
import { fitSituationalAwarenessPayload } from './situationalAwarenessSize';
import { getExtraSituationalAwarenessContext } from './useExtraSituationalAwarenessContext';

// Pushed directly rather than waiting for a render: the re-render a preceding
// updateExtraSituationalAwarenessContext triggers may not have flushed, and is
// never scheduled at all when that call changed nothing. Merged onto the last
// full payload because setSituationalAwareness replaces the agent's context.
export function syncSituationalAwareness(agentEl) {
  if (!(agentEl !== null && agentEl !== void 0 && agentEl.setSituationalAwareness)) return;
  var currentRoute = window.location.pathname;
  var payload = fitSituationalAwarenessPayload(_objectSpread(_objectSpread({}, getLastFullContext(currentRoute)), {}, {
    currentRoute: currentRoute
  }, getExtraSituationalAwarenessContext()));

  // Pushing a smaller payload instead would replace the agent's context
  // wholesale, and a repeat click schedules no re-render to restore it.
  if (!payload) return;
  pushSituationalAwareness(agentEl, payload);
}